import { createApi } from "@reduxjs/toolkit/query/react";
import { btBaseQuery } from "src/Common/common";

// Define a service using a base URL and expected endpoints
export const countryApi = createApi({
	reducerPath: "countryApi",
	baseQuery: btBaseQuery,
	tagTypes: ["Country"],

	endpoints: (builder) => ({
		getCountrys: builder.query<bt_mcountry[], void>({
			query: () => `country/`,
			providesTags: ["Country"],
		}),
		getCountryById: builder.query<bt_mcountry, string>({
			query: (id) => `country/byid/${id}`,
			providesTags: ["Country"],
		}),
		getCountryByCode: builder.query<bt_mcountry, string>({
			query: (code) => `country/code/${code}`,
			providesTags: ["Country"],
		}),
		insertCountry: builder.mutation({
			query: (country) => ({
				url: `/country/`,
				method: "POST",
				body: country,
			}),
			invalidatesTags: ["Country"],
		}),
		updateCountry: builder.mutation({
			query: (country) => ({
				url: `/country/`,
				method: "PUT",
				body: country,
			}),
			invalidatesTags: ["Country"],
		}),
		deleteCountry: builder.mutation({
			query: (country) => ({
				url: `/country/${country.ct_id}`,
				method: "DELETE",
				body: country,
			}),
			invalidatesTags: ["Country"],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetCountrysQuery,
	useGetCountryByIdQuery,
	useGetCountryByCodeQuery,
	useInsertCountryMutation,
	useUpdateCountryMutation,
	useDeleteCountryMutation,
} = countryApi;
